/**
 * i18n.js — Vertalingen NL / EN
 * Gebruik via useLang() hook (zie LangContext.jsx)
 */

const translations = {
  nl: {
    // Navigatie
    nav_dashboard:   'Dashboard',
    nav_audits:      'Audits',
    nav_clients:     'Klanten',
    nav_frameworks:  'Frameworks',
    nav_templates:   'Templates',
    nav_reports:     'Rapporten',
    nav_users:       'Gebruikers',
    nav_background_jobs: 'Achtergrondtaken',
    nav_logout:      'Afmelden',
    refresh:         'Vernieuwen',
    bgj_title:        'Achtergrondtaken',
    bgj_subtitle:     'Overzicht van AI-taken die op de achtergrond lopen of liepen.',
    bgj_none:         'Geen achtergrondtaken.',
    bgj_col_status:   'Status',
    bgj_col_audit:    'Audit',
    bgj_col_progress: 'Voortgang',
    bgj_col_processed:'Verwerkt',
    bgj_col_errors:   'Fouten',
    bgj_col_started:  'Gestart',
    bgj_col_finished: 'Klaar',
    bgj_col_actions:  'Acties',
    bgj_stop:         'Stoppen',
    bgj_delete:       'Verwijderen',
    bgj_confirm_delete: 'Deze taak verwijderen uit het overzicht?',
    bgj_st_running:     'Bezig',
    bgj_st_done:        'Klaar',
    bgj_st_error:       'Fout',
    bgj_st_stopped:     'Gestopt',
    bgj_st_interrupted: 'Onderbroken',

    // Auth
    login_title:     'Aanmelden',
    login_email:     'E-mailadres',
    login_password:  'Wachtwoord',
    login_submit:    'Aanmelden',
    login_error:     'Ongeldige inloggegevens',

    // Dashboard
    dash_title:      'Dashboard',
    dash_open_audits: 'Lopende audits',
    dash_clients:    'Klanten',
    dash_recent:     'Recente audits',

    // Audits
    audits_title:    'Audits',
    audit_new:       'Nieuwe audit',
    audit_name:      'Naam',
    audit_client:    'Klant',
    audit_framework: 'Framework',
    audit_date:      'Datum',
    audit_status:    'Status',
    audit_auditor:   'Auditor',
    audit_language:  'Rapporttaal',
    audit_scope:     'Toepassingsgebied',
    audit_progress:  'Voortgang',
    audit_save:      'Opslaan',
    audit_cancel:    'Annuleren',
    audit_delete:    'Verwijderen',
    audit_close:     'Audit afsluiten',

    // Audit statussen
    status_draft:        'Concept',
    status_in_progress:  'Bezig',
    status_review:       'Review',
    status_closed:       'Afgesloten',
    status_archived:     'Gearchiveerd',

    // Findings
    findings_title:       'Controls',
    finding_notes:        'Notities (bullet points)',
    finding_notes_hint:   'Schrijf hier je korte notities tijdens de audit',
    finding_situation:    'Huidige situatie',
    finding_finding:      'Bevinding',
    finding_recommendation: 'Aanbeveling / acties',
    finding_priority:     'Prioriteit',
    finding_due_date:     'Streefdatum',
    finding_evidence:     'Bewijsstukken',
    finding_save:         'Opslaan',
    finding_polish:       'Polishen met AI',
    finding_polished:     'Gepolisht',

    // Finding statussen
    fs_niet_beoordeeld:  'Niet beoordeeld',
    fs_conform:          'Conform',
    fs_niet_conform:     'Niet conform',
    fs_observatie:       'Observatie',
    fs_kans_verbetering: 'Kans voor verbetering',
    fs_nvt:              'N.v.t.',

    // Prioriteiten
    prio_laag:     'Laag',
    prio_gemiddeld: 'Gemiddeld',
    prio_hoog:     'Hoog',
    prio_kritiek:  'Kritiek',

    // Polish
    polish_title:         'AI-polish',
    polish_language:      'Taal rapport',
    polish_include_actions: 'Actiepunten voorstellen',
    polish_run:           'Polishen',
    polish_running:       'Bezig met polishen…',
    polish_done:          'findings verwerkt',
    polish_review_hint:   'Controleer de AI-tekst hieronder en pas aan waar nodig.',
    polish_what:          'Wat polishen?',
    polish_f_situation:   'Huidige situatie',
    polish_f_finding:     'Bevinding',
    polish_f_actions:     'Acties',
    polish_action_count:  'Aantal acties (1–5)',
    polish_mode:          'Bestaande tekst',
    polish_overwrite:     'Overschrijven',
    polish_fill_empty:    'Enkel lege vakken aanvullen',
    polish_one_running:   'AI polisht dit control…',
    login_forgot:         'Wachtwoord vergeten?',
    forgot_intro:         'Vul je e-mailadres in; we sturen je een link om je wachtwoord opnieuw in te stellen.',
    forgot_submit:        'Reset-link sturen',
    forgot_sent:          'Als dit e-mailadres bij ons bekend is, ontvang je zo een link om je wachtwoord in te stellen.',
    forgot_back:          'Terug naar inloggen',
    reset_invalid:        'Deze link is ongeldig of verlopen. Vraag een nieuwe aan.',
    reset_success:        'Je wachtwoord is ingesteld. Je kunt nu inloggen.',
    reset_title:          'Nieuw wachtwoord instellen',
    reset_title_invite:   'Welkom — stel je wachtwoord in',
    reset_intro:          'Kies een nieuw wachtwoord voor je account',
    reset_intro_invite:   'Kies een wachtwoord om je account te activeren',
    reset_password:       'Nieuw wachtwoord',
    reset_password_confirm: 'Bevestig wachtwoord',
    reset_submit:         'Wachtwoord opslaan',
    reset_too_short:      'Wachtwoord moet minstens 8 tekens bevatten.',
    reset_mismatch:       'De wachtwoorden komen niet overeen.',
    user_password_invite_hint: 'leeg laten = uitnodiging per e-mail',
    user_link_sent:       'link verstuurd',
    user_send_invite:     'Uitnodiging sturen',
    user_send_reset:      'Reset-link sturen',
    user_mfa_reset:       'MFA resetten',
    user_mfa_reset_confirm: 'MFA uitschakelen voor deze gebruiker? Hij moet daarna opnieuw instellen.',
    user_mfa_reset_done:  'MFA gereset',
    on:                   'Aan',
    mfa_login_intro:      'Voer de 6-cijferige code uit je authenticator-app in.',
    mfa_code:             'Code',
    mfa_verify:           'Verifiëren',
    account_title:        'Account & beveiliging',
    account_mfa:          'Tweestapsverificatie (MFA)',
    account_mfa_on:       'MFA is ingeschakeld',
    account_mfa_intro:    'Beveilig je account extra met een authenticator-app.',
    account_mfa_enable:   'MFA inschakelen',
    account_mfa_disable:  'MFA uitschakelen',
    account_mfa_scan:     'Scan deze QR-code met je authenticator-app en voer dan de code in:',
    account_mfa_manual:   'Of voer handmatig deze sleutel in',
    account_mfa_confirm:  'Bevestigen',
    account_mfa_enabled:  'MFA is ingeschakeld.',
    account_mfa_disabled: 'MFA is uitgeschakeld.',
    account_change_pw:    'Wachtwoord wijzigen',
    account_current_pw:   'Huidig wachtwoord',
    account_pw_changed:   'Je wachtwoord is gewijzigd.',
    ver_versions:         'Versies',
    ver_title:            'Versiegeschiedenis',
    ver_none:             'Nog geen versies vastgelegd.',
    ver_version:          'Versie',
    ver_label:            'Type',
    ver_date:             'Datum',
    ver_by:               'Door',
    ver_published:        'Gepubliceerd',
    ver_restore:          'Terugzetten',
    ver_restore_confirm:  'Versie {v} terugzetten? De huidige staat wordt eerst als versie bewaard.',
    ver_restored:         'Teruggezet naar versie {v}.',
    hist_title:           'Geschiedenis',
    hist_none:            'Nog geen wijzigingen.',
    hist_f_status:            'Status',
    hist_f_notes:             'Notities',
    hist_f_current_situation: 'Huidige situatie',
    hist_f_finding:           'Bevinding',
    hist_f_recommendation:    'Aanbeveling',
    hist_f_priority:          'Prioriteit',
    hist_f_due_date:          'Streefdatum',
    hist_f_assigned_to:       'Toegewezen aan',
    hist_f_evidence_notes:    'Bewijs/referenties',
    portal_scope:         'Toepassingsgebied',
    portal_my_reports:    'Mijn rapporten',
    portal_code_title:    'Toegangscode vereist',
    portal_code_intro:    'Dit rapport is beveiligd. Voer de toegangscode in die u ontving.',
    portal_code_submit:   'Openen',
    portal_home_title:    'Mijn rapporten',
    portal_home_none:     'Er zijn nog geen rapporten met u gedeeld.',
    portal_no_session:    'Open eerst een gedeelde rapportlink om uw rapporten te zien.',
    portal_expires:       'verloopt',
    share_title:          'Rapport delen',
    share_contact:        'Contactpersoon',
    share_no_contact:     'Algemene link (geen contact)',
    share_expires_days:   'Verloopt na (dagen)',
    share_code:           'Toegangscode',
    share_code_ph:        'optioneel',
    share_send_email:     'E-mail versturen naar contact',
    share_create:         'Link aanmaken',
    share_created:        'Deel-link aangemaakt.',
    share_emailed:        'e-mail verstuurd',
    share_copy:           'Kopiëren',
    share_existing:       'Bestaande links',
    share_none:           'Nog geen deel-links.',
    share_viewed:         'Laatst bekeken',
    share_revoke:         'Intrekken',
    share_revoke_confirm: 'Deze deel-link intrekken? De klant kan het rapport dan niet meer openen.',
    share_sent:           'E-mail verstuurd.',
    share_st_active:      'Actief',
    share_st_expired:     'Verlopen',
    share_st_revoked:     'Ingetrokken',
    ev_verify:            'Integriteit controleren',
    ev_verify_ok:         'Integriteit OK — bestand ongewijzigd',
    ev_verify_fail:       'Let op: bestand wijkt af van de opgeslagen hash',
    ev_verify_none:       'Geen hash geregistreerd',
    ev_verify_error:      'Controle mislukt — opnieuw proberen',

    // Gebruikers
    user_new:           'Nieuwe gebruiker',
    user_name:          'Naam',
    user_email:         'E-mail',
    user_role:          'Rol',
    user_active:        'Actief',
    user_inactive:      'Inactief',
    user_password:      'Wachtwoord',
    user_password_hint: 'leeg = ongewijzigd',
    role_admin:         'Beheerder',
    role_auditor:       'Auditor',
    role_viewer:        'Lezer',

    // Clients
    clients_title:   'Klanten',
    client_new:      'Nieuwe klant',
    client_name:     'Naam',
    client_vat:      'BTW-nummer',
    client_sector:   'Sector',
    client_contact:  'Contactpersoon',
    client_email:    'E-mail',
    client_phone:    'Telefoon',
    client_address:  'Adres',
    client_save:     'Opslaan',
    client_logo:     'Logo',
    client_logo_hint:'PNG, JPG of SVG, max 2 MB',
    client_audits:   'Audits',
    client_no_logo:  'Geen logo',

    // Contacten
    contact_new:       'Contactpersoon toevoegen',
    contact_name:      'Naam',
    contact_role:      'Functie',
    contact_email:     'E-mail',
    contact_phone:     'Telefoon',
    contact_primary:   'Primair contact',
    contact_notes:     'Notities',
    contact_email_btn: 'E-mail sturen',
    contact_no_email:  'Geen e-mailadres',

    // E-mail
    email_subject:  'Onderwerp',
    email_body:     'Bericht',
    email_send:     'Verzenden',
    email_sending:  'Verzenden…',
    email_sent:     'E-mail verzonden',
    email_to:       'Aan',

    // Rapport
    report_pdf:   'PDF genereren',
    report_generating: 'PDF wordt gegenereerd…',

    // Rapportenoverzicht (A1)
    reports_title:      'Rapportenoverzicht',
    reports_none:       'Nog geen bewaarde rapporten.',
    rep_save:           'Rapport opslaan',
    rep_save_pdf:       'Opslaan als PDF',
    rep_save_word:      'Opslaan als Word',
    rep_saving:         'Opslaan…',
    rep_saved:          'Rapport opgeslagen in het dossier.',
    rep_section:        'Bewaarde rapporten',
    rep_col_audit:      'Audit',
    rep_col_client:     'Klant',
    rep_col_format:     'Formaat',
    rep_col_version:    'Versie',
    rep_col_created:    'Bewaard op',
    rep_col_by:         'Door',
    rep_recs_yes:       'incl. aanbevelingen',
    rep_recs_no:        'zonder aanbevelingen',
    rep_download:       'Downloaden',
    rep_delete_confirm: 'Dit bewaarde rapport verwijderen?',
    preview:            'Voorbeeld',
    preview_failed:     'Voorbeeld kon niet geladen worden.',
    col_columns:        'Kolommen',
    col_resize_hint:    'Sleep de rand van een kolomkop om de breedte aan te passen; dubbelklik zet hem terug. Rechtsklik op de kop opent dit menu.',
    col_reset_widths:   'Standaardbreedtes herstellen',
    more_actions:       'Meer acties',
    col_section:        'Sectie',
    col_finding_preview:'Bevindingspreview',
    col_assigned:       'Toegewezen aan',
    editor_bold:        'Vet',
    editor_italic:      'Cursief',
    editor_underline:   'Onderstrepen',
    editor_ul:          'Opsomming',
    editor_ol:          'Genummerde lijst',
    editor_link:        'Link invoegen',
    editor_image:       'Afbeelding invoegen',
    editor_image_failed:'Afbeelding uploaden mislukt.',
    maturity:           'Maturiteit',
    maturity_na:        'Niet gescoord',
    maturity_hint:      'CMMI-schaal 0–5 (alleen ISO 27001 Annex A).',
    maturity_per_theme: 'Maturiteit per thema',
    maturity_avg:       'Gemiddelde',
    maturity_scored:    'Gescoord',
    maturity_none_yet:  'Nog geen maturiteit gescoord — scoor per Annex A-bevinding.',
    rep_fields_title:      'Velden in het rapport',
    rep_field_situation:   'Huidige situatie',
    rep_field_finding:     'Bevinding',
    rep_field_recommendation: 'Aanbeveling',
    rep_field_priority:    'Prioriteit',
    rep_field_due_date:    'Streefdatum',
    rep_notes_never:       'Privénotities worden nooit opgenomen.',
    rep_template_hint:     'Voor dit framework is een eigen sjabloon actief: uitvinken maakt de waarden leeg, maar hele kolommen verwijderen kan alleen in het sjabloon zelf of via het ingebouwde rapport (audit zonder sjabloon).',

    // Mailmodule (A4)
    nav_mail:              'Mail',
    saved:                 'Opgeslagen',
    mail_send_title:       'Rapport mailen',
    mail_send:             'Versturen',
    mail_to:               'Aan',
    mail_to_required:      'Vul een ontvanger in.',
    mail_pick_contact:     '— Kies een contact —',
    mail_template:         'Sjabloon',
    mail_no_template:      '— Geen sjabloon —',
    mail_subject:          'Onderwerp',
    mail_body:             'Bericht',
    mail_merge_hint:       'Gebruik merge-velden zoals {{recipient_name}} en {{audit_name}}.',
    mail_preview:          'Voorbeeld',
    mail_tab_templates:    'Sjablonen',
    mail_tab_settings:     'Instellingen',
    mail_tab_log:          'Verzendlog',
    mail_tpl_required:     'Naam, onderwerp en bericht zijn verplicht.',
    mail_tpl_delete_confirm: 'Dit sjabloon verwijderen?',
    mail_tpl_name:         'Naam',
    mail_tpl_default:      'Standaard',
    mail_tpl_new:          'Nieuw sjabloon',
    mail_tpl_none:         'Nog geen sjablonen.',
    mail_merge_fields:     'Beschikbare merge-velden',
    mail_settings_hint:    'Standaardwaarden voor uitgaande mail. Verzending loopt via de relay; geen SMTP-wachtwoord nodig.',
    mail_signature:        'Handtekening (HTML)',
    mail_log_none:         'Nog geen verzonden mail.',
    mail_log_when:         'Verzonden',
    mail_log_status:       'Status',
    mail_log_sent:         'Verzonden',
    mail_log_failed:       'Mislukt',

    // Auditees (A3)
    auditees:              'Auditees',
    auditees_none:         'Geen auditees gekozen',
    auditees_general_hint: 'Gelden voor de hele audit; per bevinding kun je afwijken.',
    auditees_inherit:      'Erft de algemene auditees',
    auditees_finding_hint: 'Laat leeg om de algemene auditees van de audit te gebruiken.',

    // Algemeen
    save:     'Opslaan',
    cancel:   'Annuleren',
    delete:   'Verwijderen',
    edit:     'Bewerken',
    close:    'Sluiten',
    loading:  'Laden…',
    error:    'Er is een fout opgetreden',
    confirm_delete: 'Weet je zeker dat je dit wilt verwijderen?',
    lang_nl:  'NL',
    lang_en:  'EN',
    all:      'Alle',
    of:       'van',
    assessed: 'beoordeeld',

    // Auditplan (sessies)
    plan_title:           'Auditplan',
    plan_header:          'Algemene gegevens',
    plan_audit_type:      'Audittype',
    plan_location:        'Auditlocatie',
    plan_contact:         'Contactpersoon',
    plan_execution:       'Uitvoering',
    plan_exec_onsite:     'Volledig on-site',
    plan_exec_hybrid:     'Deels remote',
    plan_exec_remote:     'Volledig remote',
    plan_criteria:        'Auditcriteria',
    plan_objectives:      'Auditdoelstellingen',
    plan_method:          'Auditmethode',
    plan_documents:       'Vooraf op te vragen documentatie',
    plan_focus:           'Aandachtsgebied',
    plan_lines_hint:      'Eén punt per regel.',
    plan_agenda:          'Agenda',
    plan_add:             'Agendapunt toevoegen',
    plan_template:        'Standaardplanning laden',
    plan_template_intro:  'Berekent de agenda uit de standaardsessies van dit framework: de audittijd (minstens het opgegeven %) gaat naar opening, sessies en vergaderingen, de eigen tijd naar voorbereiding, verwerking en rapportage. De duur van de sessies schaalt mee. Enkel de controls in scope worden ingepland: de tijd per sessie volgt hoeveel ervan in scope zitten, sessies zonder controls in scope vervallen.',
    plan_gen_total_hours: 'Totale tijd (u)',
    plan_gen_audit_pct:   'Audittijd (%)',
    plan_gen_prep_pct:    'Voorbereiding (% eigen tijd)',
    plan_gen_rhythm:      'Dagritme',
    plan_gen_day_start:   'Begin werkdag',
    plan_gen_day_end:     'Einde werkdag',
    plan_gen_lunch_start: 'Lunch om',
    plan_gen_lunch_min:   'Lunch (min)',
    plan_gen_coffee_min:  'Koffiepauze (min, 0 = geen)',
    plan_gen_processing_min: 'Verwerking auditor (min/dag)',
    plan_gen_meetings:    'Vaste agendapunten (min)',
    plan_gen_opening_min: 'Openingsvergadering',
    plan_gen_daystart_min:'Dagstart',
    plan_gen_feedback_min:'Dagterugkoppeling',
    plan_gen_closing_prep_min: 'Voorbereiding slot',
    plan_gen_closing_min: 'Slotvergadering',
    plan_gen_h:           'u',
    plan_gen_day:         'auditdag',
    plan_gen_days:        'auditdagen',
    plan_gen_day_ends:    'einde',
    plan_gen_audit_time:  'Audittijd',
    plan_gen_sessions:    'sessies',
    plan_gen_meetings_short: 'vergaderingen',
    plan_gen_own_time:    'Eigen tijd',
    plan_gen_prep:        'voorbereiding',
    plan_gen_processing:  'verwerking',
    plan_gen_reporting:   'rapportage',
    plan_gen_scope:       'Controls in scope verdeeld over',
    plan_gen_dropped:     'vervallen (geen controls in scope)',
    plan_gen_no_controls: 'geen controls in scope',
    plan_gen_unplanned:   'In scope maar in geen enkele sessie',
    plan_gen_start_required: 'Nodig om de agenda over de dagen te verdelen',
    plan_template_start:  'Eerste auditdag',
    plan_template_replace:'Bestaande agenda vervangen',
    plan_template_done:   'Standaardplanning geladen',
    plan_not_in_scope:    'Niet in scope, overgeslagen',
    plan_word:            'Auditplan (Word)',
    plan_empty:           'Nog geen agenda. Laad de standaardplanning of voeg zelf agendapunten toe.',
    plan_no_day:          'Zonder datum',
    plan_kind:            'Soort',
    plan_kind_session:    'Sessie',
    plan_kind_meeting:    'Vergadering',
    plan_kind_break:      'Pauze',
    plan_kind_other:      'Overige',
    plan_day:             'Datum',
    plan_start:           'Van',
    plan_end:             'Tot',
    plan_block:           'Thema (dagdeel)',
    plan_code:            'Code',
    plan_item_title:      'Titel',
    plan_topics:          'Bespreekpunten',
    plan_attention:       'Specifieke aandachtspunten',
    plan_auditee_note:    'Voorstel auditee (functie)',
    plan_item_location:   'Locatie',
    plan_controls:        'Normonderdelen (hoofdsessie)',
    plan_related:         'Raakvlak',
    plan_controls_none:   'Niets gekozen',
    plan_controls_search: 'Zoek op nummer of titel…',
    plan_controls_hint:   'Lichtgrijs = al gekozen in een andere sessie (kan toch, bv. als raakvlak).',
    plan_coverage:        'Dekking',
    plan_uncovered:       'Nog niet ingepland',
    plan_out_of_scope:    'gekoppelde controls zitten niet meer in de scope',
    plan_all_covered:     'Alle controls in scope zijn ingepland.',
    plan_delete_confirm:  'Dit agendapunt verwijderen?',
    plan_session_filter:  'Alle sessies',
    plan_session_none:    'Niet ingepland',
    plan_saved:           'Opgeslagen',
    session_now:          'Nu bezig volgens de planning',
    session_follow:       'Sessie volgen',
    session_leave:        'Sessie verlaten (alle controls)',
    session_all:          'alle controls',
  },

  en: {
    // Navigation
    nav_dashboard:   'Dashboard',
    nav_audits:      'Audits',
    nav_clients:     'Clients',
    nav_frameworks:  'Frameworks',
    nav_templates:   'Templates',
    nav_reports:     'Reports',
    nav_users:       'Users',
    nav_background_jobs: 'Background tasks',
    nav_logout:      'Sign out',
    refresh:         'Refresh',
    bgj_title:        'Background tasks',
    bgj_subtitle:     'Overview of AI tasks running or run in the background.',
    bgj_none:         'No background tasks.',
    bgj_col_status:   'Status',
    bgj_col_audit:    'Audit',
    bgj_col_progress: 'Progress',
    bgj_col_processed:'Processed',
    bgj_col_errors:   'Errors',
    bgj_col_started:  'Started',
    bgj_col_finished: 'Finished',
    bgj_col_actions:  'Actions',
    bgj_stop:         'Stop',
    bgj_delete:       'Delete',
    bgj_confirm_delete: 'Remove this task from the overview?',
    bgj_st_running:     'Running',
    bgj_st_done:        'Done',
    bgj_st_error:       'Error',
    bgj_st_stopped:     'Stopped',
    bgj_st_interrupted: 'Interrupted',

    // Auth
    login_title:     'Sign in',
    login_email:     'Email address',
    login_password:  'Password',
    login_submit:    'Sign in',
    login_error:     'Invalid credentials',

    // Dashboard
    dash_title:       'Dashboard',
    dash_open_audits: 'Active audits',
    dash_clients:     'Clients',
    dash_recent:      'Recent audits',

    // Audits
    audits_title:    'Audits',
    audit_new:       'New audit',
    audit_name:      'Name',
    audit_client:    'Client',
    audit_framework: 'Framework',
    audit_date:      'Date',
    audit_status:    'Status',
    audit_auditor:   'Auditor',
    audit_language:  'Report language',
    audit_scope:     'Scope',
    audit_progress:  'Progress',
    audit_save:      'Save',
    audit_cancel:    'Cancel',
    audit_delete:    'Delete',
    audit_close:     'Close audit',

    // Audit statuses
    status_draft:       'Draft',
    status_in_progress: 'In progress',
    status_review:      'Review',
    status_closed:      'Closed',
    status_archived:    'Archived',

    // Findings
    findings_title:         'Controls',
    finding_notes:          'Notes (bullet points)',
    finding_notes_hint:     'Write your short notes here during the audit',
    finding_situation:      'Current situation',
    finding_finding:        'Finding',
    finding_recommendation: 'Recommendation / actions',
    finding_priority:       'Priority',
    finding_due_date:       'Target date',
    finding_evidence:       'Evidence',
    finding_save:           'Save',
    finding_polish:         'Polish with AI',
    finding_polished:       'Polished',

    // Finding statuses
    fs_niet_beoordeeld:  'Not assessed',
    fs_conform:          'Compliant',
    fs_niet_conform:     'Non-compliant',
    fs_observatie:       'Observation',
    fs_kans_verbetering: 'Opportunity',
    fs_nvt:              'N/A',

    // Priorities
    prio_laag:      'Low',
    prio_gemiddeld: 'Medium',
    prio_hoog:      'High',
    prio_kritiek:   'Critical',

    // Polish
    polish_title:           'AI polish',
    polish_language:        'Report language',
    polish_include_actions: 'Suggest action points',
    polish_run:             'Polish',
    polish_running:         'Polishing…',
    polish_done:            'findings processed',
    polish_review_hint:     'Review the AI-generated text below and adjust where needed.',
    polish_what:            'What to polish?',
    polish_f_situation:     'Current situation',
    polish_f_finding:       'Finding',
    polish_f_actions:       'Actions',
    polish_action_count:    'Number of actions (1–5)',
    polish_mode:            'Existing text',
    polish_overwrite:       'Overwrite',
    polish_fill_empty:      'Only fill empty fields',
    polish_one_running:     'AI is polishing this control…',
    login_forgot:           'Forgot password?',
    forgot_intro:           'Enter your email address and we will send you a link to reset your password.',
    forgot_submit:          'Send reset link',
    forgot_sent:            'If this email address is known to us, you will receive a link to set your password shortly.',
    forgot_back:            'Back to sign in',
    reset_invalid:          'This link is invalid or has expired. Please request a new one.',
    reset_success:          'Your password has been set. You can now sign in.',
    reset_title:            'Set a new password',
    reset_title_invite:     'Welcome — set your password',
    reset_intro:            'Choose a new password for your account',
    reset_intro_invite:     'Choose a password to activate your account',
    reset_password:         'New password',
    reset_password_confirm: 'Confirm password',
    reset_submit:           'Save password',
    reset_too_short:        'Password must be at least 8 characters.',
    reset_mismatch:         'The passwords do not match.',
    user_password_invite_hint: 'leave empty = email invitation',
    user_link_sent:         'link sent',
    user_send_invite:       'Send invitation',
    user_send_reset:        'Send reset link',
    user_mfa_reset:         'Reset MFA',
    user_mfa_reset_confirm: 'Disable MFA for this user? They will have to set it up again.',
    user_mfa_reset_done:    'MFA reset',
    on:                     'On',
    mfa_login_intro:        'Enter the 6-digit code from your authenticator app.',
    mfa_code:               'Code',
    mfa_verify:             'Verify',
    account_title:          'Account & security',
    account_mfa:            'Two-factor authentication (MFA)',
    account_mfa_on:         'MFA is enabled',
    account_mfa_intro:      'Add extra protection to your account with an authenticator app.',
    account_mfa_enable:     'Enable MFA',
    account_mfa_disable:    'Disable MFA',
    account_mfa_scan:       'Scan this QR code with your authenticator app, then enter the code:',
    account_mfa_manual:     'Or enter this key manually',
    account_mfa_confirm:    'Confirm',
    account_mfa_enabled:    'MFA has been enabled.',
    account_mfa_disabled:   'MFA has been disabled.',
    account_change_pw:      'Change password',
    account_current_pw:     'Current password',
    account_pw_changed:     'Your password has been changed.',
    ver_versions:           'Versions',
    ver_title:              'Version history',
    ver_none:               'No versions recorded yet.',
    ver_version:            'Version',
    ver_label:              'Type',
    ver_date:               'Date',
    ver_by:                 'By',
    ver_published:          'Published',
    ver_restore:            'Restore',
    ver_restore_confirm:    'Restore version {v}? The current state will be saved as a version first.',
    ver_restored:           'Restored to version {v}.',
    hist_title:             'History',
    hist_none:              'No changes yet.',
    hist_f_status:            'Status',
    hist_f_notes:             'Notes',
    hist_f_current_situation: 'Current situation',
    hist_f_finding:           'Finding',
    hist_f_recommendation:    'Recommendation',
    hist_f_priority:          'Priority',
    hist_f_due_date:          'Due date',
    hist_f_assigned_to:       'Assigned to',
    hist_f_evidence_notes:    'Evidence/references',
    portal_scope:           'Scope',
    portal_my_reports:      'My reports',
    portal_code_title:      'Access code required',
    portal_code_intro:      'This report is protected. Enter the access code you received.',
    portal_code_submit:     'Open',
    portal_home_title:      'My reports',
    portal_home_none:       'No reports have been shared with you yet.',
    portal_no_session:      'Open a shared report link first to see your reports.',
    portal_expires:         'expires',
    share_title:            'Share report',
    share_contact:          'Contact',
    share_no_contact:       'General link (no contact)',
    share_expires_days:     'Expires after (days)',
    share_code:             'Access code',
    share_code_ph:          'optional',
    share_send_email:       'Send email to contact',
    share_create:           'Create link',
    share_created:          'Share link created.',
    share_emailed:          'email sent',
    share_copy:             'Copy',
    share_existing:         'Existing links',
    share_none:             'No share links yet.',
    share_viewed:           'Last viewed',
    share_revoke:           'Revoke',
    share_revoke_confirm:   'Revoke this share link? The client will no longer be able to open the report.',
    share_sent:             'Email sent.',
    share_st_active:        'Active',
    share_st_expired:       'Expired',
    share_st_revoked:       'Revoked',
    ev_verify:              'Verify integrity',
    ev_verify_ok:           'Integrity OK — file unchanged',
    ev_verify_fail:         'Warning: file differs from the stored hash',
    ev_verify_none:         'No hash recorded',
    ev_verify_error:        'Check failed — try again',

    // Users
    user_new:           'New user',
    user_name:          'Name',
    user_email:         'Email',
    user_role:          'Role',
    user_active:        'Active',
    user_inactive:      'Inactive',
    user_password:      'Password',
    user_password_hint: 'leave blank to keep unchanged',
    role_admin:         'Admin',
    role_auditor:       'Auditor',
    role_viewer:        'Viewer',

    // Clients
    clients_title:   'Clients',
    client_new:      'New client',
    client_name:     'Name',
    client_vat:      'VAT number',
    client_sector:   'Sector',
    client_contact:  'Contact person',
    client_email:    'Email',
    client_phone:    'Phone',
    client_address:  'Address',
    client_save:     'Save',
    client_logo:     'Logo',
    client_logo_hint:'PNG, JPG or SVG, max 2 MB',
    client_audits:   'Audits',
    client_no_logo:  'No logo',

    // Contacts
    contact_new:       'Add contact',
    contact_name:      'Name',
    contact_role:      'Role',
    contact_email:     'Email',
    contact_phone:     'Phone',
    contact_primary:   'Primary contact',
    contact_notes:     'Notes',
    contact_email_btn: 'Send email',
    contact_no_email:  'No email address',

    // Email
    email_subject:  'Subject',
    email_body:     'Message',
    email_send:     'Send',
    email_sending:  'Sending…',
    email_sent:     'Email sent',
    email_to:       'To',

    // Report
    report_pdf:        'Generate PDF',
    report_generating: 'Generating PDF…',

    // Reports overview (A1)
    reports_title:      'Reports',
    reports_none:       'No saved reports yet.',
    rep_save:           'Save report',
    rep_save_pdf:       'Save as PDF',
    rep_save_word:      'Save as Word',
    rep_saving:         'Saving…',
    rep_saved:          'Report saved to the audit file.',
    rep_section:        'Saved reports',
    rep_col_audit:      'Audit',
    rep_col_client:     'Client',
    rep_col_format:     'Format',
    rep_col_version:    'Version',
    rep_col_created:    'Saved on',
    rep_col_by:         'By',
    rep_recs_yes:       'incl. recommendations',
    rep_recs_no:        'without recommendations',
    rep_download:       'Download',
    rep_delete_confirm: 'Delete this saved report?',
    preview:            'Preview',
    preview_failed:     'Preview could not be loaded.',
    col_columns:        'Columns',
    col_resize_hint:    'Drag the edge of a column header to resize it; double-click resets it. Right-click the header to open this menu.',
    col_reset_widths:   'Reset column widths',
    more_actions:       'More actions',
    col_section:        'Section',
    col_finding_preview:'Finding preview',
    col_assigned:       'Assigned to',
    editor_bold:        'Bold',
    editor_italic:      'Italic',
    editor_underline:   'Underline',
    editor_ul:          'Bullet list',
    editor_ol:          'Numbered list',
    editor_link:        'Insert link',
    editor_image:       'Insert image',
    editor_image_failed:'Image upload failed.',
    maturity:           'Maturity',
    maturity_na:        'Not scored',
    maturity_hint:      'CMMI scale 0–5 (ISO 27001 Annex A only).',
    maturity_per_theme: 'Maturity per theme',
    maturity_avg:       'Average',
    maturity_scored:    'Scored',
    maturity_none_yet:  'No maturity scored yet — score per Annex A finding.',
    rep_fields_title:      'Fields in the report',
    rep_field_situation:   'Current situation',
    rep_field_finding:     'Finding',
    rep_field_recommendation: 'Recommendation',
    rep_field_priority:    'Priority',
    rep_field_due_date:    'Due date',
    rep_notes_never:       'Private notes are never included.',
    rep_template_hint:     'A custom template is active for this framework: unchecking clears the values, but removing whole columns is only possible in the template itself or via the built-in report (audit without a template).',

    // Mail module (A4)
    nav_mail:              'Mail',
    saved:                 'Saved',
    mail_send_title:       'Email report',
    mail_send:             'Send',
    mail_to:               'To',
    mail_to_required:      'Enter a recipient.',
    mail_pick_contact:     '— Pick a contact —',
    mail_template:         'Template',
    mail_no_template:      '— No template —',
    mail_subject:          'Subject',
    mail_body:             'Message',
    mail_merge_hint:       'Use merge fields such as {{recipient_name}} and {{audit_name}}.',
    mail_preview:          'Preview',
    mail_tab_templates:    'Templates',
    mail_tab_settings:     'Settings',
    mail_tab_log:          'Send log',
    mail_tpl_required:     'Name, subject and message are required.',
    mail_tpl_delete_confirm: 'Delete this template?',
    mail_tpl_name:         'Name',
    mail_tpl_default:      'Default',
    mail_tpl_new:          'New template',
    mail_tpl_none:         'No templates yet.',
    mail_merge_fields:     'Available merge fields',
    mail_settings_hint:    'Defaults for outgoing mail. Delivery runs via the relay; no SMTP password needed.',
    mail_signature:        'Signature (HTML)',
    mail_log_none:         'No emails sent yet.',
    mail_log_when:         'Sent',
    mail_log_status:       'Status',
    mail_log_sent:         'Sent',
    mail_log_failed:       'Failed',

    // Auditees (A3)
    auditees:              'Auditees',
    auditees_none:         'No auditees selected',
    auditees_general_hint: 'Apply to the whole audit; you can override per finding.',
    auditees_inherit:      'Inherits the general auditees',
    auditees_finding_hint: 'Leave empty to use the audit’s general auditees.',

    // General
    save:     'Save',
    cancel:   'Cancel',
    delete:   'Delete',
    edit:     'Edit',
    close:    'Close',
    loading:  'Loading…',
    error:    'An error occurred',
    confirm_delete: 'Are you sure you want to delete this?',
    lang_nl:  'NL',
    lang_en:  'EN',
    all:      'All',
    of:       'of',
    assessed: 'assessed',

    // Audit plan (sessions)
    plan_title:           'Audit plan',
    plan_header:          'General information',
    plan_audit_type:      'Audit type',
    plan_location:        'Audit location',
    plan_contact:         'Contact person',
    plan_execution:       'Execution',
    plan_exec_onsite:     'Fully on-site',
    plan_exec_hybrid:     'Partly remote',
    plan_exec_remote:     'Fully remote',
    plan_criteria:        'Audit criteria',
    plan_objectives:      'Audit objectives',
    plan_method:          'Audit method',
    plan_documents:       'Documentation requested in advance',
    plan_focus:           'Focus area',
    plan_lines_hint:      'One item per line.',
    plan_agenda:          'Agenda',
    plan_add:             'Add agenda item',
    plan_template:        'Load standard plan',
    plan_template_intro:  'Calculates the agenda from the standard sessions of this framework: audit time (at least the given %) goes to the opening, sessions and meetings, own time to preparation, processing and reporting. Session durations scale along. Only controls in scope are planned: time per session follows how many of them are in scope, sessions without controls in scope are dropped.',
    plan_gen_total_hours: 'Total time (h)',
    plan_gen_audit_pct:   'Audit time (%)',
    plan_gen_prep_pct:    'Preparation (% of own time)',
    plan_gen_rhythm:      'Daily rhythm',
    plan_gen_day_start:   'Workday start',
    plan_gen_day_end:     'Workday end',
    plan_gen_lunch_start: 'Lunch at',
    plan_gen_lunch_min:   'Lunch (min)',
    plan_gen_coffee_min:  'Coffee break (min, 0 = none)',
    plan_gen_processing_min: 'Auditor processing (min/day)',
    plan_gen_meetings:    'Fixed agenda items (min)',
    plan_gen_opening_min: 'Opening meeting',
    plan_gen_daystart_min:'Daily start',
    plan_gen_feedback_min:'Daily feedback',
    plan_gen_closing_prep_min: 'Closing preparation',
    plan_gen_closing_min: 'Closing meeting',
    plan_gen_h:           'h',
    plan_gen_day:         'audit day',
    plan_gen_days:        'audit days',
    plan_gen_day_ends:    'ends',
    plan_gen_audit_time:  'Audit time',
    plan_gen_sessions:    'sessions',
    plan_gen_meetings_short: 'meetings',
    plan_gen_own_time:    'Own time',
    plan_gen_prep:        'preparation',
    plan_gen_processing:  'processing',
    plan_gen_reporting:   'reporting',
    plan_gen_scope:       'Controls in scope spread over',
    plan_gen_dropped:     'dropped (no controls in scope)',
    plan_gen_no_controls: 'no controls in scope',
    plan_gen_unplanned:   'In scope but in no session',
    plan_gen_start_required: 'Needed to spread the agenda over the days',
    plan_template_start:  'First audit day',
    plan_template_replace:'Replace existing agenda',
    plan_template_done:   'Standard plan loaded',
    plan_not_in_scope:    'Not in scope, skipped',
    plan_word:            'Audit plan (Word)',
    plan_empty:           'No agenda yet. Load the standard plan or add agenda items yourself.',
    plan_no_day:          'No date',
    plan_kind:            'Type',
    plan_kind_session:    'Session',
    plan_kind_meeting:    'Meeting',
    plan_kind_break:      'Break',
    plan_kind_other:      'Other',
    plan_day:             'Date',
    plan_start:           'From',
    plan_end:             'To',
    plan_block:           'Theme (half-day)',
    plan_code:            'Code',
    plan_item_title:      'Title',
    plan_topics:          'Discussion points',
    plan_attention:       'Specific points of attention',
    plan_auditee_note:    'Proposed auditee (role)',
    plan_item_location:   'Location',
    plan_controls:        'Requirements (main session)',
    plan_related:         'Related',
    plan_controls_none:   'Nothing selected',
    plan_controls_search: 'Search by number or title…',
    plan_controls_hint:   'Light grey = already selected in another session (still allowed, e.g. as related).',
    plan_coverage:        'Coverage',
    plan_uncovered:       'Not planned yet',
    plan_out_of_scope:    'linked controls are no longer in scope',
    plan_all_covered:     'All controls in scope are planned.',
    plan_delete_confirm:  'Delete this agenda item?',
    plan_session_filter:  'All sessions',
    plan_session_none:    'Not planned',
    plan_saved:           'Saved',
    session_now:          'In progress according to the plan',
    session_follow:       'Follow session',
    session_leave:        'Leave session (all controls)',
    session_all:          'all controls',
  },
};

export default translations;
